export const CART_UPDATE_PENDING_EVENT = 'cart.update-pending-changed';

let PENDING_COUNT = 0;

const publishPending = (pending) => {
  if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
    LIFE_CYCLE_EVENT_BUS.trigger(CART_UPDATE_PENDING_EVENT, { pending });
  }
};

export const isCartUpdatePending = () => PENDING_COUNT > 0;

export const trackCartUpdate = (promise) => {
  PENDING_COUNT += 1;
  if (PENDING_COUNT === 1) {
    publishPending(true);
  }
  const settle = () => {
    PENDING_COUNT -= 1;
    if (PENDING_COUNT === 0) {
      publishPending(false);
    }
  };
  promise.then(settle, settle);
  return promise;
};
